/**
 * Maps a locale string to a display shorthand.
 * - Any English variant → 'EN'
 * - All other locales   → upper-case version of the original
 *
 * @example
 * formatLocale('en-ca')   // 'EN'
 * formatLocale('En_US')   // 'EN'
 * formatLocale('fr')      // 'FR'
 * formatLocale(undefined) // 'EN'
 */
const defaultToEnglishLocale = ({ locale }: { locale: string }): string => {
  // Treat missing locale as English by default
  if (!locale) return 'EN';

  // Collapse any case/layout of an English locale code to 'EN'
  const isEnglish = /^en([-_][a-z]{2})?$/i.test(locale);
  return isEnglish ? 'EN' : locale.toUpperCase();
};

export default defaultToEnglishLocale;
